const getTotalProductPrice = ()=> {
    var old = JSON.parse(localStorage.getItem("carrito"))
    var i = 0;
    var total = 0
    for (; i < old.length ;){
        total = total + old[i].cant * old[i].precio
        i++
    }
    return total
}

export { getTotalProductPrice }